import axios from 'axios';
import { getDeviceId, getChannelId } from 'utils';
import errorHandler from './errorHandler';
import { cookieKey } from 'assets/Constants';
const api = axios.create({
  headers: {
    'Content-type': 'application/json',
    'x-device-id': '',
  },
});

const requestMaker = (
  baseQuery,
  requestData,
  additionalHeaders = {},
  accessToken,
  progressCallback
) => {
  let val = '';
  try {
    val = localStorage && localStorage.getItem(cookieKey);
  } catch (error) {
    console.warn('No en-token found : ', error);
  }

  if (!navigator.onLine) {
    throw new Error('No internet connection');
  }
  const headers = {
    ...additionalHeaders,
    'x-device-id': getDeviceId(),
    'x-channel-id': getChannelId(),
    [cookieKey]: accessToken || val ? val : undefined,
  };
  const HEADER_CONFIG = {
    headers,
  };
  if (progressCallback) {
    HEADER_CONFIG.onUploadProgress = progressEvent => {
      progressCallback(progressEvent);
    };
  }
  if (progressCallback) {
    HEADER_CONFIG.onDownloadProgress = progressEvent => {
      progressCallback(progressEvent);
    };
  }

  let baseurl = process.env.REACT_APP_HOST_PATH || '/';
  baseurl = baseurl.slice(0, baseurl.length - 1);
  baseQuery = `${baseurl}${baseQuery}`;
  let apiCall = api.post(baseQuery, requestData, HEADER_CONFIG);

  return apiCall
    .then(response => {
      if (response.data && response.data[cookieKey]) {
        localStorage && localStorage.setItem(cookieKey, response.data[cookieKey]);
      }
      return response;
    })
    .catch(error => {
      const pe = errorHandler(error);
      console.error('Error in NH-WC :: ', error, pe);
      throw error;
    });
};

export default requestMaker;
